import React, { FC, useState } from "react";
import InfoCard from "src/components/Cards/InfoCard";
import SmallIcon from "src/components/Common/Icons/SmallIcon";
import { DoorIcon, LinkIcon, SpotlightIcon } from "@100mslive/react-icons";
import { Box, Flex, Text, Tooltip } from "@100mslive/roomkit-react";

interface formSidebarProps {
  steps: Record<string, { key: string; name: string }>;
  activeStepIndex: number;
  infoTitle?: string;
  infoBody?: string;
  infoLink?: string;
  roomName?: string;
  templateName?: string;
  subdomain?: string;
}

const iconStyle = { minWidth: "20px", minHeight: "20px" };

const FormSidebar: FC<formSidebarProps> = ({
  steps,
  activeStepIndex,
  infoTitle,
  infoBody,
  infoLink,
  roomName,
  templateName,
  subdomain,
}) => {
  const [showInfoCard, setShowInfoCard] = useState(true);
  return (
    <Box>
      {activeStepIndex !== 0 ? (
        <Box
          css={{
            backgroundColor: "$surface_default",
            borderRadius: "$1",
            p: "$10",
            border: "1px solid $border_bright",
            mb: "$14",
            w: "min(20vw, 320px)",
          }}
        >
          <Tooltip
            title={<Text variant="caption">{templateName}</Text>}
            side="bottom"
            align="center"
            disabled={!templateName}
          >
            {templateName ? (
              <Text
                variant="h6"
                css={{
                  color: "$on_surface_high",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "290px",
                  whiteSpace: "nowrap",
                }}
              >
                {templateName}
              </Text>
            ) : null}
          </Tooltip>
          {roomName ? (
            <Flex
              align="center"
              gap="2"
              css={{ color: "$on_surface_low", mt: "$sm" }}
            >
              <DoorIcon style={iconStyle} />
              <Text variant="sm" css={{ color: "$on_surface_medium" }}>
                {`Default Room: ${roomName}`}
              </Text>
            </Flex>
          ) : null}
          {subdomain ? (
            <Flex
              align="center"
              css={{ color: "$on_surface_low", mt: "$sm", gap: "$5" }}
            >
              <LinkIcon style={iconStyle} />
              <Text variant="sm" css={{ color: "$on_surface_medium" }}>
                {subdomain.includes(
                  `${process.env.REACT_APP_VERCEL_BASE_DOMAIN}`
                )
                  ? `Link: ${subdomain}`
                  : `Link: ${subdomain.concat(
                      `${process.env.REACT_APP_VERCEL_BASE_DOMAIN}`
                    )}`}
              </Text>
            </Flex>
          ) : null}
          <Flex
            css={{ h: "1px", w: "100%", bg: "$border_default", my: "$8" }}
          />
          <Flex css={{ c: "$primary_bright" }} align="center" justify="start">
            <SmallIcon>
              <SpotlightIcon />
            </SmallIcon>
            <Text
              css={{ ml: "$2", fontWeight: "$regular", c: "$primary_bright" }}
              variant="caption"
            >
              You can edit this later
            </Text>
          </Flex>
        </Box>
      ) : null}

      <Box
        css={{
          fontSize: "$h5",
          c: "$on_surface_high",
        }}
      >
        <ul className="parallel-line">
          {Object.values(steps).map((step, index: number) => (
            <Box
              key={step.key}
              css={{
                color:
                  activeStepIndex > index
                    ? "$primary_bright"
                    : activeStepIndex === index
                    ? "$on_surface_high"
                    : "$on_surface_low",
              }}
            >
              <li>
                <Text
                  variant="md"
                  css={{
                    color:
                      activeStepIndex > index
                        ? "$primary_bright"
                        : activeStepIndex === index
                        ? "$on_surface_high"
                        : "$on_surface_low",
                  }}
                >
                  {step.name}
                </Text>
              </li>
            </Box>
          ))}
        </ul>
      </Box>
      <InfoCard
        open={showInfoCard}
        setOpen={setShowInfoCard}
        title={infoTitle}
        body={infoBody}
        link={infoLink}
        componentId="guided.onboarding"
        hideCross
      />
    </Box>
  );
};

export default FormSidebar;
